import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

const actionsApi = {
  getActionsInfo(): Promise<AxiosResponse<string[]>> {
    return BaseApi.get('api/v1/personal/actions');
  },
};

export default actionsApi;
